import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddBrokerPaymentModal({ onClose, onSuccess }) {
  const [brokers, setBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState('');
  const [amount, setAmount] = useState('');
  const [paymentType, setPaymentType] = useState('cash');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBrokers();
  }, []);

  const fetchBrokers = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-brokers`);
      setBrokers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/add-broker-payment`, {
        broker_name: selectedBroker,
        amount: parseFloat(amount),
        payment_type: paymentType,
        recorded_by: localStorage.getItem('userId')
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding payment: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Add Broker Payment</h2>
        <form onSubmit={handleSubmit}>
          <select value={selectedBroker} onChange={(e) => setSelectedBroker(e.target.value)} required>
            <option value="">Select Broker</option>
            {brokers.map(b => (
              <option key={b.broker_name} value={b.broker_name}>
                {b.broker_name} - Total Purchases: Rs.{b.total_purchases?.toLocaleString()}
              </option>
            ))}
          </select>
          <input type="number" step="0.01" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} required />
          <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
            <option value="cash">Cash</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="online">Online</option>
          </select>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Adding...' : 'Add Payment'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBrokerPaymentModal;